import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { delay } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { UsuarioService } from 'src/app/services/usuario.service';
import { SurveyService } from 'src/app/services/customers/survey.service';
import { ClientsService } from 'src/app/services/customers/clients.service';
import { ProspectService } from 'src/app/services/customers/prospect.service';

import { User } from 'src/app/models/user.model';
import { ClientModel } from 'src/app/models/customers/client.model';
import { ProspectModel } from 'src/app/models/customers/prospect.model';
import { SurveyModel } from 'src/app/models/customers/survey.model';

import { environment } from 'src/environments/environment.prod';
import { FileUploadService } from '../../../../services/files/file-upload.service';

const base_url = environment.base_url;

@Component({
    selector: 'app-pre-installation-survey',
    templateUrl: './pre-installation-survey.component.html',
    styleUrls: ['./pre-installation-survey.component.scss'],
    standalone: false
})
export class PreInstallationSurveyComponent implements OnInit {

 @ViewChild('inputfile') inputfile: ElementRef;

  regresar: string = '/business';
  clientForm: UntypedFormGroup;
  surveyForm: UntypedFormGroup;
  clientSelected: ClientModel;
  prospect: ProspectModel;
  survey: SurveyModel;

  files_arr: File[] = [];
  files_arr_tmp: File[] = [];



  public usuario: User;
  ROLE = '';

  btnSAHide: boolean = true;

  public fileSubir: File;
  public fileData: any = null

pathFile: string = '';
imgView: string = '';
imgViewHide: boolean = false;
tipoMenu: string;

  constructor(private fb: UntypedFormBuilder,
              private router: Router,
              public activatedRoute: ActivatedRoute,
              private toastr: ToastrService,
              private usuarioService: UsuarioService,
              private surveyService: SurveyService,
              private clientsService: ClientsService,
              private prospectService: ProspectService,
              private fileuploadService: FileUploadService,
              ) { }

  ngOnInit(): void {
      this.tipoMenu = this.activatedRoute.snapshot.paramMap.get('tipoMenu');
      this.usuario = this.usuarioService.usuario;
      this.ROLE = this.usuario.role;
      this.crearFormularios();
      this.activatedRoute.params.subscribe( ({ id }) => {
        this.cargarClient(id);
      });
}

getSalesPersonName(): string {
  if(!this.clientSelected) return 'NA';
  return this.ROLE == 'SALESPER_ROLE'?
           this.usuario.name :
           this.clientSelected.sales_person;
}
getSalesPersonID(): string {
  if(!this.clientSelected) return 'NA';
  return this.ROLE == 'SALESPER_ROLE'?
          this.usuario.uid :
          this.clientSelected.sales_person_id;
}


get capacityNoValido() {
  return this.surveyForm.get('capacity').invalid && this.surveyForm.get('capacity').touched;
}



crearFormularios(){
       this.clientForm = this.fb.group({
        name_client: [{value: null, disabled: true}],
        address: [{value: null, disabled: true}],
        area: [{value: null, disabled: true}],

      });


      this.surveyForm = this.fb.group({
        ident_GUI: [''],
        ident_client: [''],
        name_client_address: [''],
        name_survey: ['', [Validators.required, Validators.minLength(1)]],
        address: ['', [Validators.required, Validators.minLength(1)]],
        capacity: ['', [Validators.required, Validators.minLength(1)]],
        room_w: [''],
        room_h: [''],
        room_d: [''],
        best_date: [''],
        files: [''],
        smaller_access: [''],
        door_hinge_side: [''],
        stand_kind: [''],
        tank_acces: [''],
        pull_delivery: [''],
        electrical_outlet: [''],
        permanent_hose: [''],
        dispensing_hose: [''],
        special_requirements: [''] ,
        client: [''],
        sales_person: [this.getSalesPersonName()],
        sales_person_id: [this.getSalesPersonID()],
        status: ['Tramitado']
    });
}


cargarClient(id: string ) {
  this.clientsService.getById( id )
                        .pipe(
                          delay(100)
                        )
                        .subscribe( resp => {

                          if ( !resp.client ) {
                            return this.router.navigateByUrl(`/dashboard`);

                          }

                          const { name_client, address, area} = resp.client;
                          this.clientForm.setValue({ name_client, address, area});
                          this.clientSelected = resp.client;
                        });


}


async newSurvey(){
  this.btnSAHide = true;
  this.surveyForm.get('ident_client').setValue(this.clientSelected._id);
  this.surveyForm.get('name_client_address').setValue(this.clientSelected.name_client_address);
  this.surveyForm.get('name_survey').setValue(this.clientSelected.name_client);
  this.surveyForm.get('address').setValue(this.clientSelected.address);
  this.surveyForm.get('client').setValue(this.clientSelected);
  this.surveyForm.get('ident_GUI').setValue(this.clientSelected.ident_GUI);
  if(this.ROLE ==='ADMIN_ROLE'){
       this.surveyForm.get('sales_person').setValue(this.getSalesPersonName());
       this.surveyForm.get('sales_person_id').setValue(this.getSalesPersonID());
  }

  let _arr = [];
  this.files_arr.forEach(item =>{
  _arr.push(item.name);
  });

  this.surveyForm.get('files').setValue(_arr);
  if (this.surveyForm.invalid) {
    return  Object.values( this.surveyForm.controls ).forEach( control => {
      control.markAsTouched();
    });
  }

   this.surveyService.create(this.surveyForm.value)
                      .subscribe(async respSurvey =>{

                                console.log(respSurvey);


                                if(respSurvey.survey){

                                  this.survey = respSurvey.survey;
                                  this.clientSelected.survey_status = 'Tramitado';

                                   this.clientsService.update(this.clientSelected, this.clientSelected._id)
                                                              .subscribe(resClient =>{ console.log(resClient);});

                                  await this.newProspect(this.clientSelected, this.survey);

                                  await this.uploadFileToSurvey(this.survey);
                                  this.surveyForm.reset({
                                                          sales_person: this.getSalesPersonName(),
                                                          sales_person_id: this.getSalesPersonID()
                                                          });

                                  this.toastr.success(respSurvey.msg);
                                  this.btnSAHide = false;
                                }



                            }, (error) =>{
                               console.log(error);
                               let _error = 'Error'
                               if(error.error.msg){
                                _error = error.error.msg;
                                }
                               this.toastr.error(_error);
                               this.btnSAHide = true;
                            });




}


setFile(_file: File) {
  const nombreCortado = _file.name.split('.');
  const extensionArchivo = nombreCortado[nombreCortado.length - 1];
  const code = new Date().getMilliseconds();
  const nombreArchivo = `S-${this.clientSelected._id}-${ code }.${ extensionArchivo }`;

  const extensionesValida = ['png', 'jpg', 'jpeg', 'gif'];
    if (!extensionesValida.includes(extensionArchivo)) {
       return this.toastr.error(`${extensionArchivo} no valid`);
    }

  var newfile = new File([_file], nombreArchivo, {
          type: _file.type,
        });

 this.files_arr_tmp.push(newfile);
  if ( !_file ) {
     return this.fileData = null;
     }

  const reader = new FileReader();
  reader.readAsDataURL( _file );
  reader.onloadend = () => {
    this.fileData = reader.result;
  };

}

removeFile(_file){

  this.files_arr_tmp = this.files_arr_tmp.filter(item => item != _file);
  this.files_arr =[... this.files_arr_tmp];


}

showFiles(){
  this.inputfile.nativeElement.value = '';
  this.files_arr =[... this.files_arr_tmp];
}

async uploadFileToSurvey(_survey){
  this.files_arr.forEach(async (_fileSubir: File) =>{
    await this.fileuploadService.uploadFile( _fileSubir, 'surveys', _survey._id, false)
                        .then(resp => {
                          if(!resp){
                               Swal.fire('Error', 'Error Upload File', 'error');
                            }else{
                               this.removeFile(_fileSubir);
                            }

                       }).catch((err) => {

                         Swal.fire('Error', 'Upload File Error' , 'error');

                       });

  });

}

previewImgFile(_file){

  if ( !_file ) {
     return this.fileData = null;
     }


  const reader = new FileReader();
  reader.readAsDataURL( _file );

  reader.onloadend = () => {
    this.fileData = reader.result;
  };

}

getFile(_file){

this.fileData = null;
this.imgView = _file.name;
this.imgViewHide = true;
this.pathFile = `${ base_url }/upload/orders/${ _file.name }`;

if(_file.size > 10){
this.previewImgFile(_file);
}


}

closeImgView(){
this.imgView = null;
this.imgViewHide = false;
this.fileData = null;
}

async newProspect(_client, _survey){

const prospect = {
  ident_GUI: _survey.ident_GUI,
  ident_client: _client._id,
  name_client_address: _client.name_client_address,
  name_prospect: _client.name_client,
  address: _client.address,
  survey_status: _survey.status,
  visit_plans: _client.visit_plans,
  client: _client,
  sales_person: this.getSalesPersonName(),
  sales_person_id: this.getSalesPersonID(),
  survey: _survey
}

  this.prospectService.create(prospect)
                      .subscribe(async respProspect =>{
                            }, (error) =>{
                              console.log(error);
                            });



}





}
